import api from "../axiosConfig"

const resource = "/blocos"

function getDefaultParams(page, pageSize) {
  return {
    "sort[0]": "descricao",
    "pagination[page]": `${page}`,
    "pagination[pageSize]": `${pageSize}`,
  }
}

export default {
  async searchByName(name, page, pageSize) {
    const params = getDefaultParams(page, pageSize)
    if (name) {
      params["filters[descricao][$containsi]"] = name
    }
    return api.get(`${resource}`, { params })
  },
  async count() {
    const res = await api.get(`${resource}`, {
      params: {
        "pagination[pageSize]": `${0}`,
      },
    })
    return res.data.meta.pagination.total
  },

  async getAll(page = 1, pageSize = 0) {
    const params = getDefaultParams(page, pageSize || (await this.count()))
    return api.get(`${resource}`, { params })
  },

  getOne(id) {
    return api.get(`${resource}/${id}`, {
      params: { populate: "salas" },
    })
  },
  create(payload) {
    return api.post(`${resource}`, payload)
  },
  update(id, payload) {
    return api.put(`${resource}/${id}`, payload)
  },
  delete(id) {
    return api.delete(`${resource}/${id}`)
  },
}
